import { Clipboard } from '@chilipiper/utils'
import { CopyLinkType } from './types'

export const copyBookingLink = (copyLinkType: CopyLinkType, bookingLink?: string) => {
  let message =
    copyLinkType === CopyLinkType.CopyLink ? 'Link is copied' : 'Single-use link is copied'
  if (bookingLink) {
    Clipboard.copy(bookingLink)
  } else {
    message =
      copyLinkType === CopyLinkType.CopyLink ? 'Cannot copy link!' : 'Cannot copy single-use link!'
  }
  return {
    message,
    success: !!bookingLink,
  }
}
